<template>
<div class="chapter">
<div class="inner_page">
<section aria-labelledby="headertoc01" class="chapter" epub:type="toc" id="toc" role="doc-toc">
<header id="headertoc01">
<h1 class="ctfm"><span aria-label="vi" class="page" id="pvi" role="doc-pagebreak"></span><span aria-label="vii" class="page" id="pvii" role="doc-pagebreak"></span>Contents</h1>
</header>
<p class="tocfm"><a class="xref" href="#/chibecker0008#preface">Preface to the Third Edition</a></p>
<p class="toc"><a class="xref" href="#/chibecker0009#ch01">1   FRESHMAN ENGLISH FOR GRADUATE STUDENTS</a></p>
<p class="toc"><a class="xref" href="#/chibecker0010#ch02">2   PERSONA AND AUTHORITY</a></p>
<p class="toc"><a class="xref" href="#/chibecker0011#ch03">3   ONE RIGHT WAY</a></p>
<p class="toc"><a class="xref" href="#/chibecker0012#ch04">4   EDITING BY EAR</a></p>
<p class="toc"><a class="xref" href="#/chibecker0013#ch05">5   LEARNING TO WRITE AS A PROFESSIONAL</a></p>
<p class="toc"><a class="xref" href="#/chibecker0014#ch06">6   RISK<span class="sm">,</span> <i>by Pamela Richards</i></a></p>
<p class="toc"><a class="xref" href="#/chibecker0015#ch07">7   GETTING IT OUT THE DOOR</a></p>
<p class="toc"><a class="xref" href="#/chibecker0016#ch08">8   TERRORIZED BY THE LITERATURE</a></p>
<p class="toc"><a class="xref" href="#/chibecker0017#ch09">9   WRITING WITH COMPUTERS<span class="sm">,</span> THEN AND NOW</a></p>
<p class="toc"><a class="xref" href="#/chibecker0018#ch10">10   A FINAL WORD</a></p>
<p class="tocbmf"><a class="xref" href="#/chibecker0019#refs">References</a></p>
<p class="tocbm"><a class="xref" href="#/chibecker0020#index">Index</a></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-becker-0007.vue?6cda921d